import { Sys, Sys_query } from './SysCM';
import * as RichTextCM from "./RichTextCM";

export const typeName: string = 'BookingAlert';

export interface BookingAlert {
    __typename: string;
    internalName: string;
    alertText: RichTextCM.RichText;
    filterMode: 'None' | 'Opt-in' | 'Opt-out';
    venueCodes?: string[];
    sys: Sys;
}

export const query = `
__typename
internalName
alertText {
  ${RichTextCM.query}
}
filterMode
venueCodes
${Sys_query}
`;
